export default [
    {
        name: 'word',
        sortField: 'word',
        type: 'string',
        callback: 'similarKeyWord',
        defaultSearch: true,
        useInFilter: true,
    },
    {
        name: 'cnt',
        sortField: 'cnt',
        type: 'number',
        callback: 'number',
        defaultSearch: false,
        useInFilter: true,
        isDefault: true
    },
    {
        name: 'frequency',
        sortField: 'ws',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        isDefault: true,
        useInFilter: true,
    },
    {
        name: 'numwords',
        sortField: 'numwords',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'adscnt',
        sortField: 'adscnt',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'docs',
        sortField: 'docs',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'mincpc',
        sortField: 'cpc_min',
        type: 'float',
        callback: 'float',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'maxcpc',
        sortField: 'cpc_max',
        type: 'float',
        callback: 'float',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'serpf',
        sortField: 'serp',
        type: 'string',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: false,
    },
    {
        name: '__component:key-meta-data',
        dataClass: 'key-meta-data',
        useInFilter: false,
    },

]
